export default {
    intro: '초성과 뜻을 단서로 어휘를 추리해 보세요!',
    meaning: '뜻',
    example: '예',
    emptyExample: '예문이 없습니다.',
    table: {
        question: '어휘',
        emptyMessage: '내용이 없어요.',
        answerRate: '정답률',
    },
    student: {
        selectionGuide: '이 정보를 보고 어떤 어휘인지 알 수 있나요?',
        know: '알아요!',
        dontKnow: '몰라요',
        submit: '제출하기',
        next: '다음으로',
        inputGuide: '생각한 어휘를 입력해보세요!',
        inputPlaceholder: '정답을 입력해주세요',
        meaningN: '뜻 {n}',
        imageN: '이미지 {n}',
        videoN: '영상 {n}',
        additionalMaterials: '추가 자료',
    },
    result: {
        myAnswer: '내 답변:',
        know: '알아요',
        dontKnow: '몰라요',
        dontKnowBracket: '(몰라요)',
    },
    stats: {
        mostIncorrect: '많이 틀린 어휘',
        vocabulary: '어휘',
        meaning: '뜻',
        accuracy: '정답률',
        moreN: '외 {n}개',
    },
    reactions: {
        knowSelect: [
            '오! 자신감이 넘치는데요?',
            '그래요! 한번 확인해 볼까요?',
            '좋아요! 정말 맞는지 볼게요!',
            '훌륭해요! 어떤 어휘일까요?',
            '멋져요! 답을 확인해 봐요!',
        ],
        correct: [
            '정답이에요! 정말 잘했어요!',
            '와! 완벽하게 알고 있네요!',
            '맞았어요! 대단해요!',
            '훌륭해요! 정확히 맞혔어요!',
            '잘했어요! 정말 멋져요!',
        ],
        dontKnowSelect: [
            '괜찮아요! 같이 알아봐요!',
            '걱정 마세요! 예문을 보면 알 수 있어요!',
            '괜찮아요! 힌트를 보면 알 수 있어요!',
        ],
        maxAttempts: '괜찮아요. 어떤 어휘인지 같이 알아봐요!',
        maxAttemptsNext: '어떤 어휘인지 알아보고, 다음 어휘로 이동해요!',
    },
    teacher: {
        modal: {
            clearConfirm: {
                title: '대기 어휘를 모두 비울까요?',
                message: '등록 대기 중인 어휘가 모두 삭제됩니다. 계속하시겠습니까?',
            },
            closeConfirm: {
                title: '입력한 문항을 삭제할까요?',
                message: '닫으면 대기열의 어휘가 모두 사라집니다. 계속하시겠습니까?',
            },
            questionDelete: {
                title: '문항을 삭제할까요?',
                // {word}: 삭제 대상 문항의 표제어. 활동에서 영구 제거됨을 안내.
                message: "'{word}' 문항이 활동에서 삭제됩니다. 계속하시겠습니까?",
            },
            waitItemDelete: {
                title: '대기 어휘를 삭제할까요?',
                // {word}: 삭제 대상 대기 어휘. 대기열에서만 제거되며 활동에는 영향 없음을 안내.
                message: "'{word}'을(를) 대기열에서 삭제합니다. 계속하시겠습니까?",
            },
            // {count}: BE가 사전 중복으로 건너뛴 어휘 수
            duplicateNotice: '이미 등록된 어휘 {count}개는 추가되지 않았습니다.',
            // {count}: 뜻이 없어 등록 불가로 건너뛴 어휘 수
            skippedNotice: '뜻이 비어 있어 {count}개 어휘가 등록되지 않았습니다.',
            // 혼합(뜻없는 어휘 + 뜻있는 어휘) 등록 시 확인 모달
            mixedEmptyConfirm: {
                title: '등록할까요?',
                // {empty}: 뜻 비어 등록 불가 개수
                line1: '뜻이 비어 있는 어휘 {empty}개는 추가되지 않습니다.',
                // {valid}: 실제 등록될 개수
                line2: '나머지 {valid}개만 활동에 등록할까요?',
            },
            // 뜻없는 어휘만 있을 때 등록 불가 안내
            onlyEmptyNotice: {
                title: '등록할 수 없습니다',
                message: '등록할 수 있는 어휘가 없어요. 뜻이 비어 있는 어휘만 남아 있습니다.',
            },
            registerFailed: '등록에 실패했습니다.',
        },
    },
};
